/**
 * Money display helpers for the public marketing/purchase pages.
 * Amounts arrive from the purchase catalogue endpoint in integer pence.
 */

// Formats integer pence as a display pounds string, e.g. 169500 -> '£1,695'
// and 99950 -> '£999.50'. Whole-pound amounts drop the decimals to match the
// marketing style ('£1,695', never '£1,695.00').
export function formatPounds(amountPence) {
  const pounds = amountPence / 100;
  const hasPence = Math.round(amountPence) % 100 !== 0;
  return (
    '£' +
    pounds.toLocaleString('en-GB', {
      minimumFractionDigits: hasPence ? 2 : 0,
      maximumFractionDigits: hasPence ? 2 : 0,
    })
  );
}

// Strips the leading 'Improve ' prefix Stripe product names carry so plan
// tiles read 'Growth' rather than 'Improve Growth'.
export function planDisplayName(name) {
  return String(name || '').replace(/^improve\s+/i, '');
}
